import React, { useEffect, useRef, useCallback, useState } from 'react';
import { Pannellum } from 'pannellum-react';
import Styles from '../../../src/Css/View360/Interior360.module.css';
import InteriorMobileToggleHandler from './HotspotToggleHandler/InteriorMobileToggleHandler';
import { checkIsV2, checkIsV3 } from '../../utils/getAppVersion';
import { amplitudeEvents } from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { setInteriorHotspotIndex } from '../../Redux/Reducers/View360Reducer/View360ActionController';
import { setToggleInteriorHotspot, setToggleHotspotView } from '../../Redux/Reducers/View360Reducer/View360ActionController';



function drawHotspotLine(hotSpotDiv, targetDiv, isV3 = false, ToggleInteriorHotspots = false, selectedTemplate, isMobileFullScreen = false) {  
  if (!ToggleInteriorHotspots) {
    return;
  }
  const existingSvgs = document.querySelectorAll('svg.hotspot-svg');
  existingSvgs.forEach(svg => svg.remove());
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.style.position = "fixed";
  svg.style.top = "0";
  svg.style.left = "0";
  svg.style.width = "100%";
  svg.style.height = "100%";
  svg.style.pointerEvents = "none";
  svg.style.zIndex = "10";
  svg.classList.add("hotspot-svg");

  // Re-fetch the current position to ensure accuracy
  const hotspotRect = hotSpotDiv.getBoundingClientRect(); 
  
  // Perfect center calculation - place circle exactly at hotspot center with slight top-left adjustment
  const circleCenterX = hotspotRect.left + hotspotRect.width / 2 - 3; // Shift 2px left
  const circleCenterY = hotspotRect.top + hotspotRect.height / 2 - 3; // Shift 2px up
  
  // Use the same dimensions as the existing hover circle
  const circleRadius = 16.5; // Match the existing hover circle radius
  
  
  // Draw the complete circle exactly around the hotspot - matching hover circle
  const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  circle.setAttribute("cx", circleCenterX);
  circle.setAttribute("cy", circleCenterY);
  circle.setAttribute("r", circleRadius);
  circle.setAttribute("fill", "none"); // Ensure no fill
  circle.setAttribute("stroke", "#fff");
  circle.setAttribute("stroke-width", "1"); // Match the existing hover circle stroke-width
  circle.classList.add("circle");

  const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
  if (isV3) {
    if(selectedTemplate === "t2"){
      line.setAttribute("x1", circleCenterX);
      line.setAttribute("y1", circleCenterY);
      line.setAttribute("x2", 750); // static value, adjust as needed
      line.setAttribute("y2", circleCenterY);
    }
    else if(selectedTemplate === "t1"){
      line.setAttribute("x1", circleCenterX);
      line.setAttribute("y1", circleCenterY);
      const modalLeftEdgeX = window.innerWidth - 16 - 390; // Full modal width to get left edge
      line.setAttribute("x2", modalLeftEdgeX);
      line.setAttribute("y2", circleCenterY);
    }
  } else if (targetDiv) {
    // Calculate the angle from hotspot center to target div
    const targetCenterX = targetDiv.offsetLeft + targetDiv.offsetWidth / 2;
    const targetCenterY = targetDiv.offsetTop + targetDiv.offsetHeight / 2;
    
    const angle = Math.atan2(
      targetCenterY - circleCenterY,
      targetCenterX - circleCenterX
    );
    const startX = circleCenterX + circleRadius * Math.cos(angle);
    const startY = circleCenterY + circleRadius * Math.sin(angle);
    
    // End the line at the edge of the target div
    const endX = targetCenterX - (targetDiv.offsetWidth / 2) * Math.cos(angle);
    const endY = targetCenterY - (targetDiv.offsetHeight / 2) * Math.sin(angle);
    
    line.setAttribute("x1", startX);
    line.setAttribute("y1", startY);
    line.setAttribute("x2", endX);
    line.setAttribute("y2", endY);
  }
  line.classList.add("connection-line");

  svg.appendChild(circle);
  if(!isMobileFullScreen) svg.appendChild(line);
  document.body.appendChild(svg);
  
  // Add real-time line updating to follow hotspot movements
  const updateLinePosition = () => {
    if (!document.body.contains(svg)) return; // Stop if SVG is removed
    
    const currentHotspotRect = hotSpotDiv.getBoundingClientRect();
    
    // Check if hotspot is still visible and valid
    if (currentHotspotRect.width === 0 || currentHotspotRect.height === 0) {
      return;
    }
    
    // Perfect center calculation for real-time updates with slight top-left adjustment
    const currentCenterX = currentHotspotRect.left + currentHotspotRect.width / 2 - 3; // Shift 2px left
    const currentCenterY = currentHotspotRect.top + currentHotspotRect.height / 2 - 3; // Shift 2px up
    
    // Use the same fixed radius as the hover circle
    const currentRadius = 16.5; // Match the existing hover circle radius
    
    // Update circle position and radius for perfect centering and coverage
    circle.setAttribute("cx", currentCenterX);
    circle.setAttribute("cy", currentCenterY);
    circle.setAttribute("r", currentRadius);
    
    // Update line position
    if (isV3) {
      if(selectedTemplate === "t2"){
        line.setAttribute("x1", currentCenterX);
        line.setAttribute("y1", currentCenterY);
        line.setAttribute("x2", 750);
        line.setAttribute("y2", currentCenterY);
      }
      else if(selectedTemplate === "t1"){
        line.setAttribute("x1", currentCenterX);
        line.setAttribute("y1", currentCenterY);
        const modalLeftEdgeX = window.innerWidth - 16 - 390; // Full modal width to get left edge
        line.setAttribute("x2", modalLeftEdgeX);
        line.setAttribute("y2", currentCenterY);
      }
    } else if (targetDiv) {
      const targetCenterX = targetDiv.offsetLeft + targetDiv.offsetWidth / 2;
      const targetCenterY = targetDiv.offsetTop + targetDiv.offsetHeight / 2;
      
      const angle = Math.atan2(
        targetCenterY - currentCenterY,
        targetCenterX - currentCenterX
      );
      
      // Use current radius for line start calculation
      const startX = currentCenterX + currentRadius * Math.cos(angle);
      const startY = currentCenterY + currentRadius * Math.sin(angle);
      const endX = targetCenterX - (targetDiv.offsetWidth / 2) * Math.cos(angle);
      const endY = targetCenterY - (targetDiv.offsetHeight / 2) * Math.sin(angle);
      
      line.setAttribute("x1", startX);
      line.setAttribute("y1", startY);
      line.setAttribute("x2", endX);
      line.setAttribute("y2", endY);
    }
  };
  
  // Update line position periodically to follow hotspot movements
  const lineUpdateInterval = setInterval(updateLinePosition, 50); // Update every 50ms
  
  // Store the interval ID on the SVG so it can be cleared when SVG is removed
  svg.lineUpdateInterval = lineUpdateInterval;
  
  // Clean up interval when SVG is removed
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((node) => {
        if (node === svg && svg.lineUpdateInterval) {
          clearInterval(svg.lineUpdateInterval);
          observer.disconnect();
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true });
}
const InteriorIframe = React.memo(({spanishEnterprise, selectedTemplate, handleOnLoad, state, isMobileView, hotspotDataInterior, ToggleInteriorHotspotsButton=false, hotspotImageId, interiorTimeSpent,automatedImageSpin = true, isMobileFullScreen = false, onHotspotClick }) => {
  const [hotspotsJson, setHotspotsJson] = useState(hotspotDataInterior);
  const [handlerMobileHotspot, setHandlerMobileHotspot] = useState(true);
  const [isAutoRotating, setIsAutoRotating] = useState(true);
  const [isImageIdValid, setIsImageIdValid] = useState(false);
  const [interiorEngagement, setInteriorEngagement] = useState(0);
  const [isPannellumDragging, setIsPannellumDragging] = useState(false);
  const incrementClickedInterior = useSelector(state => state.view360Reducer.incrementClickedInterior);
  const decrementClickedInterior = useSelector(state => state.view360Reducer.decrementClickedInterior);
  const toggleInteriorHotspots = useSelector(state => state.view360Reducer.toggleInteriorHotspots);
  const toggleInteriorHotspotsRef = useRef(ToggleInteriorHotspotsButton);
  const toggleHotspotView = useSelector(state => state.view360Reducer.toggleHotspotView);
  const isV2 = checkIsV2()
  const isV3 = checkIsV3()
  
  const dispatch = useDispatch();
  const toggleHotspotRef = useRef(toggleInteriorHotspots);
  const viewerRef = useRef(null);
  const isEngagementStarted = useRef(false);
  const engagementTimeout = useRef(null);
  const engagementStartTime = useRef(null);
  const isDragging = useRef(false);
  const containerRef = useRef(null);

  // Define helper functions first
  const getHotspotData = () => {
    if (isMobileView) {
      const mobileData = hotspotsJson?.interior_tagged_images?.hotspots || [];
      return mobileData;
    } else {
      const desktopData = hotspotsJson?.[0]?.hotspots || hotspotsJson || [];
      return desktopData;
    }
  };

  const convertCoordinates = (x, y) => {
    const imgWidth = 100;
    const imgHeight = 100;
    const yaw = (x / imgWidth) * 360 - 180;
    const theta = (y / imgHeight) * Math.PI;
    const pitch = (Math.PI / 2 - theta) * (180 / Math.PI);
    return {
      yaw: yaw,
      pitch: pitch
    };
  };

  const waitForHotspots = (targetIndex, currentHotspotData, maxRetries = 10, delay = 100) => {
    return new Promise((resolve, reject) => {
      let retries = 0;
      
      const checkHotspots = () => {
        const allHotspotDivs = document.querySelectorAll('.pnlm-hotspot-base');
        
        const validHotspotDivs = Array.from(allHotspotDivs).filter(div => {
          const rect = div.getBoundingClientRect();
          const isVisible = div.offsetWidth > 0 && div.offsetHeight > 0;
          const hasValidPosition = rect.width > 0 && rect.height > 0;
          const isInViewport = rect.top >= 0 && rect.left >= 0;
          
          return isVisible && hasValidPosition && isInViewport;
        });
        
        const expectedCount = currentHotspotData?.length || 0;
        
        // Check if we have enough hotspots and the target index is valid
        if (targetIndex >= expectedCount) {
          reject(new Error(`Target index ${targetIndex} is out of bounds for expected hotspot count ${expectedCount}`));
          return;
        }

        // Find the DOM element that corresponds to our target data index
        const targetHotspot = validHotspotDivs.find(div => {
          const originalIndex = div.getAttribute('data-original-index');
          return originalIndex && parseInt(originalIndex) === targetIndex;
        });

        if (targetHotspot) {
          // Double-check the hotspot is actually visible and has dimensions
          if (targetHotspot.offsetWidth > 0 && targetHotspot.offsetHeight > 0) {
            resolve(targetHotspot);
          } else if (retries < maxRetries) {
            retries++;
            setTimeout(checkHotspots, delay);
          } else {
            reject(new Error(`Hotspot at index ${targetIndex} exists but is not visible after ${maxRetries} attempts`));
          }
        } else if (retries < maxRetries) {
          retries++;
          setTimeout(checkHotspots, delay);
        } else {
          reject(new Error(`Could not find hotspot with data-original-index=${targetIndex} in DOM after ${maxRetries} attempts. Available hotspots: ${validHotspotDivs.length}`));
        }
      };
      
      checkHotspots();
    });
  };

  // Move helper functions inside component
  const rotateToHotspot = useCallback((viewer, yaw, pitch) => {
    viewer.setYaw(yaw);
    viewer.setPitch(pitch);
  }, []);

  // Add function to check if hotspot is visible in current view
  const isHotspotVisible = useCallback((hotspotDiv) => {
    if (!hotspotDiv) return false;
    
    const rect = hotspotDiv.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    // Check if hotspot is within viewport bounds
    const isInViewport = (
      rect.top >= 0 && 
      rect.left >= 0 && 
      rect.bottom <= viewportHeight && 
      rect.right <= viewportWidth
    );
    
    // Check if hotspot has valid dimensions
    const hasValidDimensions = rect.width > 0 && rect.height > 0;
    
    return isInViewport && hasValidDimensions;
  }, []);

  // Add function to rotate camera to hotspot if not visible
  const rotateToHotspotIfNeeded = useCallback(async (hotspotIndex, currentHotspotData) => {
    if (!currentHotspotData || hotspotIndex >= currentHotspotData.length) return;
    
    const hotspot = currentHotspotData[hotspotIndex];
    if (!hotspot) return;
    
    // Convert coordinates to yaw/pitch
    const { yaw, pitch } = convertCoordinates(hotspot.coordinates.x, hotspot.coordinates.y);
    
    try {
      // First check if hotspot is already visible
      const hotSpotDiv = await waitForHotspots(hotspotIndex, currentHotspotData, 3, 50); 
      
      if (!isHotspotVisible(hotSpotDiv)) {
        // Hotspot is not visible, rotate camera
        if (viewerRef.current) {
          const viewer = viewerRef.current.getViewer();
          if (viewer) {
            rotateToHotspot(viewer, yaw, pitch);
            
            // Wait longer for rotation to complete and hotspots to settle
            await new Promise(resolve => setTimeout(resolve, 600));
            
            // Re-fetch the hotspot element after rotation since its position has changed
            try {
              const rotatedHotSpotDiv = await waitForHotspots(hotspotIndex, currentHotspotData, 10, 100);
              return rotatedHotSpotDiv;
            } catch (rotationError) {
              console.warn('Could not find hotspot after rotation:', rotationError.message);
              throw rotationError;
            }
          }
        }
      } else {
        return hotSpotDiv;
      }
    } catch (error) {
      // If hotspot not found, try rotating first then wait
      if (viewerRef.current) {
        const viewer = viewerRef.current.getViewer();
        if (viewer) {
          rotateToHotspot(viewer, yaw, pitch);
          
          // Wait longer for rotation and try again with more retries
          await new Promise(resolve => setTimeout(resolve, 600));
          try {
            const rotatedHotSpotDiv = await waitForHotspots(hotspotIndex, currentHotspotData, 15, 100);
            return rotatedHotSpotDiv;
          } catch (secondError) {
            console.warn('Could not find hotspot even after rotation:', secondError.message);
            throw secondError;
          }
        }
      }
      throw error;
    }
  }, [isHotspotVisible, rotateToHotspot, viewerRef]);

  const cleanupOldHotspots = () => {
    const allHotspotDivs = document.querySelectorAll('.pnlm-hotspot-base');
    const currentHotspotData = getHotspotData();
    const expectedCount = currentHotspotData?.length || 0;
    
    if (allHotspotDivs.length > expectedCount && expectedCount > 0) {
      const hotspotsToRemove = Array.from(allHotspotDivs).slice(0, allHotspotDivs.length - expectedCount);
      hotspotsToRemove.forEach((div, index) => {
        div.remove();
      });
    }
  };

  const toggleHotspotVisibility = useCallback(() => {
    const shouldHideHotspots = (isMobileView ? ToggleInteriorHotspotsButton : !ToggleInteriorHotspotsButton) || !handlerMobileHotspot;
    const visibility = shouldHideHotspots ? 'hidden' : 'visible';
    const shouldShowHotspotsV2 = ToggleInteriorHotspotsButton;
    const visibilityV2 = shouldShowHotspotsV2 ? 'visible' : 'hidden';
    document.querySelectorAll('.pnlm-hotspot-base').forEach((e) => {
      e.style.visibility = visibility;
    });
    document.querySelectorAll('.pnlm-hotspot-base').forEach((e) => {
      e.style.visibility = visibilityV2;
    });
  }, [ToggleInteriorHotspotsButton]);

  const toggleHotspotVisibilityV3 = useCallback(() => {
    const shouldHideHotspots = (isMobileView ? toggleInteriorHotspots : !toggleInteriorHotspots) || !handlerMobileHotspot;
    const visibility = shouldHideHotspots ? 'hidden' : 'visible';
    const shouldShowHotspotsV2 = toggleInteriorHotspots;
    const visibilityV2 = shouldShowHotspotsV2 ? 'visible' : 'hidden';
    document.querySelectorAll('.pnlm-hotspot-base').forEach((e) => {
      e.style.visibility = visibility;
      e.style.display = 'block';
      e.style.opacity = '1';
    });
    document.querySelectorAll('.pnlm-hotspot-base').forEach((e) => {
      e.style.visibility = visibilityV2;
    });
  }, [toggleInteriorHotspots, handlerMobileHotspot]);
  
  useEffect(() => {
      toggleHotspotRef.current = toggleInteriorHotspots;
    // if(checkIsV3()){
    //   toggleHotspotRef.current = toggleInteriorHotspots;
    // }
    // else{
    //   toggleInteriorHotspotsRef.current = toggleInteriorHotspots;
    // }
    if(!checkIsV3()) toggleInteriorHotspotsRef.current = ToggleInteriorHotspotsButton;
  }, [toggleInteriorHotspots, ToggleInteriorHotspotsButton]);

  useEffect(() => {
    if (!hotspotDataInterior) return;
    setHotspotsJson(hotspotDataInterior);
  }, [hotspotDataInterior]);
  
  useEffect(() => {
    document.querySelectorAll('svg.hotspot-svg').forEach(svg => svg.remove());
    setTimeout(() => {
      cleanupOldHotspots();
    }, 100);
    const currentHotspotData = getHotspotData();
   
    if (
      typeof incrementClickedInterior === 'number' &&
      incrementClickedInterior >= 0 &&
      currentHotspotData && Array.isArray(currentHotspotData) && currentHotspotData.length > incrementClickedInterior
    ) {
      setTimeout(async () => {
        try {
          const hotSpotDiv = await rotateToHotspotIfNeeded(incrementClickedInterior, currentHotspotData);
          if (hotSpotDiv) {
            // Add small delay to ensure DOM has fully settled after rotation
            await new Promise(resolve => setTimeout(resolve, 100));
            
            const targetDiv = isV3 ? null : document.querySelector('.big-div');
            if (hotSpotDiv && (isV3 || targetDiv)) {
              drawHotspotLine(hotSpotDiv, targetDiv, isV3, toggleHotspotRef.current, selectedTemplate, isMobileFullScreen);
            } else {
              console.warn('Missing targetDiv for line drawing');
            }
          }
        } catch (error) {
          console.warn('Skipping line drawing for increment hotspot:', error.message);
        }
      }, 200);
    } else {
      console.warn('Invalid conditions for increment hotspot line generation - skipping line drawing');
    }
  }, [incrementClickedInterior, hotspotsJson, isV3, isMobileView, rotateToHotspotIfNeeded]);
  useEffect(() => {
    document.querySelectorAll('svg.hotspot-svg').forEach(svg => svg.remove())
    setTimeout(() => {
      cleanupOldHotspots();
    }, 100);
    const currentHotspotData = getHotspotData();
    
    if (
      typeof decrementClickedInterior === 'number' &&
      decrementClickedInterior >= 0 &&
      currentHotspotData && Array.isArray(currentHotspotData) && currentHotspotData.length > decrementClickedInterior
    ) {
      setTimeout(async () => {
        try {
          const hotSpotDiv = await rotateToHotspotIfNeeded(decrementClickedInterior, currentHotspotData);
          
          if (hotSpotDiv) {
            // Add small delay to ensure DOM has fully settled after rotation
            await new Promise(resolve => setTimeout(resolve, 100));
            
            const targetDiv = isV3 ? null : document.querySelector('.big-div');
            if (hotSpotDiv && (isV3 || targetDiv)) {
              drawHotspotLine(hotSpotDiv, targetDiv, isV3, toggleHotspotRef.current, selectedTemplate, isMobileFullScreen);
            } else {
              console.warn('Missing targetDiv for line drawing');
            }
          }
        } catch (error) {
          console.warn('Skipping line drawing for decrement hotspot:', error.message);
        }
      }, 200);
    } else {
      console.warn('Invalid conditions for decrement hotspot line generation - skipping line drawing');
    }
  }, [decrementClickedInterior, hotspotsJson, isV3, isMobileView, rotateToHotspotIfNeeded]);

  const stopAutoRotation = useCallback(() => {
    if (viewerRef.current && state?.selectedUrl?.url) {
      setTimeout(() => {
        const viewer = viewerRef?.current?.getViewer();
        if (viewer && typeof viewer.stopAutoRotate === 'function') {
          try {
            viewer.stopAutoRotate();
            setTimeout(() => {
              if (viewer.getConfig && viewer.getConfig().autoRotate) {
                viewer.stopAutoRotate();
              } else {
              }
            }, 100);
          } catch (error) {
          }
        } else {
        }
      }, 200); // Add 200ms delay
    }
  }, [state?.selectedUrl?.url, toggleInteriorHotspots]);

// Add a function to start auto-rotation
const startAutoRotation = useCallback(() => {
  if (viewerRef.current) {
    const viewer = viewerRef.current.getViewer();
    if (viewer) {
      viewer.startAutoRotate();
      setIsAutoRotating(true);
    }
  }
}, []);

// Add useEffect to handle automatedImageSpin changes
useEffect(() => {
  if (automatedImageSpin) {
    startAutoRotation();
  } else {
    stopAutoRotation();
  }
}, [automatedImageSpin, startAutoRotation, stopAutoRotation]);

 // Add a function to reset camera position
 const resetCameraPosition = useCallback(() => {
  if (viewerRef.current) {
    const viewer = viewerRef.current.getViewer();
    if (viewer) {
      // Smoothly animate to initial position
      viewer.lookAt(-35, -30, 120, 1000); // yaw, pitch, fov, duration
    }
  }
}, []);

  // Function to remove hotspot lines when dragging
  useEffect(() => {
    if(toggleInteriorHotspots){
      stopAutoRotation();
    }
  }, [toggleInteriorHotspots, stopAutoRotation]);
  
  const removeHotspotLines = useCallback(() => {
    const existingSvgs = document.querySelectorAll('svg.hotspot-svg');
    existingSvgs.forEach(svg => svg.remove());
  }, [toggleInteriorHotspots]);

  // Remove lines when dragging starts
  useEffect(() => {
    if (isPannellumDragging || !toggleInteriorHotspots) {
      removeHotspotLines();
    }
  }, [isPannellumDragging, removeHotspotLines, toggleInteriorHotspots]);

  useEffect(() => {
    const startTime = Date.now();

    return () => {
      const endTime = Date.now();
      const timeSpentMs = endTime - startTime;
      const timeSpentSeconds = timeSpentMs / 1000;

      if (typeof interiorTimeSpent === 'function') {
        interiorTimeSpent(timeSpentSeconds);
      } else {
        console.error('');
      }
    };
  }, [interiorTimeSpent]);





  let originalData = []
  const getFilteredData = (response) => {
    if (hotspotsJson.length !== 0) {
      return originalData;
    }
    const interior_array = response.data.hotspots?.[0]?.interior_tagged_images;

    const array = Array.isArray(interior_array) ? interior_array?.[0] : [];

    const h = array.hotspots;

    const filteredHotspots = h.filter(hotspot => !hotspot.reasons.includes("Seats"));

    const newHotspotsObject = [{
      ...response.data.hotspots?.[0], 
      interior_tagged_images: [     
        {
          ...array,  
          hotspots: filteredHotspots 
        }
      ]
    }];
    return newHotspotsObject;
  }
  const queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (hotspotDataInterior) {
      const isV3 = checkIsV3();
      const filteredHotspots = (isV3 && !spanishEnterprise)
        ? spanishEnterprise ? hotspotDataInterior.filter(h => h.feature && h.feature.trim() !== '') : hotspotDataInterior
        : hotspotDataInterior;
      setHotspotsJson(prev => [...new Set([...prev, ...filteredHotspots])]);
    }
  }, [hotspotDataInterior]);

  let sessionId = `session_${Math.random().toString(36).substring(2, 11)}`;

  useEffect(() => {
    const handleEngagementStart = () => {
      if (!isEngagementStarted?.current) {
        isEngagementStarted.current = true;
        engagementStartTime.current = new Date();

        amplitudeEvents({
          event: 'iframe_interior_engage_started',
          customAmplitudeEvents: {
            iframe_session_id: sessionId,
            sku_id: state?.skuId || state?.skuIdForDownload,
            enterprise_id: state?.enterpriseIdForDownload,
            skuName: state?.skuName
          }
        });
      }

      resetEngagementTimeout();
    };

    const handleEngagementEnd = () => {
      if (isEngagementStarted.current) {
        isEngagementStarted.current = false;

        const engagementEndTime = new Date();
        const durationMs = engagementEndTime - engagementStartTime.current;
        const engagementDurationSec = durationMs / 1000;
        setInteriorEngagement(engagementDurationSec - 5);

        amplitudeEvents({
          event: 'iframe_interior_engage_end',
          customAmplitudeEvents: {
            iframe_session_id: sessionId,
            sku_id: state?.skuId || state?.skuIdForDownload,
            enterprise_id: state?.enterpriseIdForDownload,
            skuName: state?.skuName,
            engagementDuration: engagementDurationSec - 5 + '  Seconds'
          }
        });

        engagementStartTime.current = null;
      }
    };

    const resetEngagementTimeout = () => {
      if (engagementTimeout?.current) {
        clearTimeout(engagementTimeout.current);
      }

      engagementTimeout.current = setTimeout(() => {
        handleEngagementEnd();
      }, 5000);
    };

    const handleMouseDown = () => {
      if (!isDragging?.current) {
        isDragging.current = true;
        handleEngagementStart();
      }
    };

    const handleMouseUp = () => {
      if (isDragging?.current) {
        isDragging.current = false;
        resetEngagementTimeout();
      }
    };

    const handleMouseLeave = () => {
      if (isDragging?.current) {
        isDragging.current = false;
        resetEngagementTimeout();
      }
    };

    const container = containerRef.current;

    if (container) {
      container.addEventListener('mousedown', handleMouseDown);
      container.addEventListener('mouseleave', handleMouseLeave);
    }
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      if (container) {
        container.removeEventListener('mousedown', handleMouseDown);
        container.removeEventListener('mouseleave', handleMouseLeave);
      }
      document.removeEventListener('mouseup', handleMouseUp);

      if (engagementTimeout?.current) {
        clearTimeout(engagementTimeout?.current);
      }

      if (isEngagementStarted?.current) {
        handleEngagementEnd();
      }
    };
  }, [
    sessionId,
    state?.skuIdForDownload,
    state?.enterpriseIdForDownload,
    amplitudeEvents
  ]);







  const validHotspots = Array.isArray(hotspotsJson) && hotspotsJson.length > 0 ? hotspotsJson : null;

  const hotspotData = (hotspotsJson || [])?.map(hotspot => ({
    focus_image_url: hotspot.focus_image_url,
    type: hotspot.reasons.join(', ') // Join the reasons into a comma-separated string
  }));
  const spanRef = useRef(null);

  useEffect(() => {
    // Your existing useEffect logic
  }, [state?.url]);

  useEffect(() => {
    const removeInOutDivs = () => {
      const divsToRemove = document.querySelectorAll('div.in, div.out');
      divsToRemove.forEach(div => {
        div.remove();
      });
    };

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          removeInOutDivs();
        }
      }

    });
    observer.observe(document.body, {
      childList: true, 
      subtree: true    
    });

    removeInOutDivs();

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    // toggleHotspotVisibility();
    // if (!checkIsV3()) {
    //   dispatch(setToggleInteriorHotspot(toggleHotspotView));
    // }
    // dispatch(setToggleInteriorHotspot(toggleHotspotView));
    const observer = new MutationObserver((mutations) => {
      if (!isV3 && mutations.some(mutation => mutation.type === 'childList' || mutation.type === 'attributes')) {
        // toggleHotspotVisibility();
      }
    });
    const hotspotContainer = document.querySelector('.pnlm-container');
    if (hotspotContainer) {
      observer.observe(hotspotContainer, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);
  const handleError = (e) => {
    console.error(e);
  };

  const [tooltipContent, setTooltipContent] = useState('');
  const [tooltipStyle, setTooltipStyle] = useState({});

  useEffect(() => {
    return () => {
      setTooltipContent('');
      setTooltipStyle({});
    };
  }, []);


  useEffect(() => {
    if (hotspotImageId === state?.selectedUrl.image_id) {
      setIsImageIdValid(true);
    }
    else setIsImageIdValid(false);
  }, [hotspotImageId, state?.selectedUrl.image_id]);

  useEffect(() => {
    const hotspotClass = toggleInteriorHotspots ? 'visible-hotspot' : 'hidden-hotspot';
    document.querySelectorAll('.pnlm-hotspot-base').forEach((hotspot) => {
      // Remove both classes first
      hotspot.classList.remove(Styles['visible-hotspot']);
      hotspot.classList.remove(Styles['hidden-hotspot']);
      // Add the appropriate class
      hotspot.classList.add(Styles[hotspotClass]);
    });
    // When hotspots become visible, reset camera position
    // if (toggleInteriorHotspots) {
    //   resetCameraPosition();
    // }
  }, [toggleInteriorHotspots]);

  function setupHotspotTooltip(hotSpotDiv, focus_image, text, stopAutoRotationFn, textSize = '14px', width = '10px', height = 'auto', textColor = 'black', background = 'white', borderRadius = '2rem') {
    let currentIndex = 0;  

    const style = document.createElement('style');
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .tooltip-content {
            animation: fadeIn 0.3s ease-out;
            position: relative;
        }
        @keyframes drawCircle {
            to { stroke-dashoffset: 0; }
        }
        .circle {
            stroke-dasharray: 103.67;
            stroke-dashoffset: 103.67;
            animation: drawCircle 0.3s linear forwards;
        }
        @keyframes ripple {
            0% { opacity: 1; transform: scale(0); }
            100% { opacity: 0; transform: scale(2); }
        }
        .ripple {
            position: absolute;
            border-radius: 50%;
            background-color: #5465FF99;
            width: 100%;
            height: 100%;
            left: -3px;
            top: -4px;
            animation: ripple 1.5s ease-out infinite;
            z-index: 0;
        }
        .big-div, .expanded-div {
            position: fixed;
            top: 20px;
            right: 20px;
            width: 250px;
            height: 150px;
            z-index: 1000;
            border-radius: 10px;
            box-shadow: 0 0 20px rgba(0,0,0,0.2);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            text-align: center;
            padding: 10px;
        }
        .expand-button, .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }
        @keyframes drawLine {
            from { stroke-dashoffset: 1000; }
            to { stroke-dashoffset: 0; }
        }
        .connection-line {
            stroke: white;
            stroke-width: 2;
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            animation: drawLine 0.5s linear forwards;
        }
    `;
    document.head.appendChild(style);
    function disableKeyboardInput() {
      window.addEventListener('keydown', preventKeyboardInput, true);
      window.addEventListener('keyup', preventKeyboardInput, true);
      }
    function enableKeyboardInput() {
      window.removeEventListener('keydown', preventKeyboardInput, true);
      window.removeEventListener('keyup', preventKeyboardInput, true);
    }
    function preventKeyboardInput(e) {
      e.stopPropagation();
      e.preventDefault();
    }
    function clearPreviousHotspot() {
      const existingBigDiv = document.querySelector('.big-div');
      const existingSvg = document.querySelector('svg.hotspot-svg');
      const existingOverlay = document.querySelector('.background-overlay');
      const existingExpandedDiv = document.querySelector('.expanded-div');

      if (existingBigDiv) {
        existingBigDiv.remove();
      }
      if (existingSvg) {
        existingSvg.remove();
      }
      if (existingOverlay) {
        existingOverlay.remove();
      }
      if (existingExpandedDiv) {
        existingExpandedDiv.remove();
      }
      enableKeyboardInput();
    }
    function createRipple() {
      const ripple = document.createElement('span');
      ripple.classList.add('ripple');

      hotSpotDiv.insertBefore(ripple, hotSpotDiv.firstChild);
      ripple.style.zIndex = '0'; 
    }
    function createTooltip() {
      if (hotSpotDiv.querySelector('.tooltip-content')) return;

      const tooltipDiv = document.createElement('div');
      tooltipDiv.className = 'tooltip-content';
      tooltipDiv.innerHTML = text;

      tooltipDiv.style.color = textColor;
      tooltipDiv.style.backgroundColor = background;
      tooltipDiv.style.borderRadius = borderRadius;
      tooltipDiv.style.padding = '2px';
      tooltipDiv.style.maxWidth = '150px';
      tooltipDiv.style.width = 'auto';
      tooltipDiv.style.height = 'auto';
      tooltipDiv.style.fontSize = textSize;
      tooltipDiv.style.zIndex = '1';

      document.body.appendChild(tooltipDiv);

      const contentWidth = tooltipDiv.offsetWidth;
      const contentHeight = tooltipDiv.offsetHeight;

      document.body.removeChild(tooltipDiv);

      tooltipDiv.style.width = `${Math.max(contentWidth, parseInt(width))}px`;
      tooltipDiv.style.height = `${Math.max(contentHeight, parseInt(height))}px`;

      hotSpotDiv.appendChild(tooltipDiv);

      tooltipDiv.style.marginLeft = `${-(tooltipDiv.offsetWidth - hotSpotDiv.offsetWidth) / 2}px`;
      tooltipDiv.style.marginTop = `${-tooltipDiv.offsetHeight - 12}px`;

      tooltipDiv.dataset.tooltipId = 'hotspot-tooltip';

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      svg.style.position = "absolute";
      svg.style.top = "-3px";
      svg.style.left = "-3px";
      svg.style.pointerEvents = "none";
      svg.style.zIndex = "1";

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      circle.setAttribute("cx", "50%");
      circle.setAttribute("cy", "50%");
      circle.setAttribute("r", "16.5");
      circle.setAttribute("fill-opacity", "0");
      circle.setAttribute("stroke", "#fff");
      circle.setAttribute("stroke-width", "1");
      circle.classList.add("circle");

      svg.appendChild(circle);
      hotSpotDiv.appendChild(svg);
    }

    function removeTooltip() {
      const tooltipDiv = hotSpotDiv.querySelector('.tooltip-content');
      const svg = hotSpotDiv.querySelector('svg');
      if (tooltipDiv && hotSpotDiv.contains(tooltipDiv)) {
        hotSpotDiv.removeChild(tooltipDiv);
      }
      if (svg && hotSpotDiv.contains(svg)) {
        hotSpotDiv.removeChild(svg);
      }
    }
    function createBackgroundOverlay() {
      const overlay = document.createElement('div');
      overlay.className = 'background-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      overlay.style.zIndex = '998';
      disableKeyboardInput();
      return overlay;
    }
    function createBigDiv(focus_image, text, initialIndex) {
      clearPreviousHotspot();
      let currentIndex = initialIndex;

      const overlay = createBackgroundOverlay();

      const bigDiv = document.createElement('div');
      bigDiv.className = 'big-div';
      bigDiv.style.height = "10rem"
      bigDiv.style.width = "20rem"
      bigDiv.style.padding = '0';
      bigDiv.style.margin = '20px';
      bigDiv.style.overflow = 'hidden';
      bigDiv.style.display = 'flex';
      bigDiv.style.flexDirection = 'column';
      bigDiv.style.alignItems = 'center';
      bigDiv.style.justifyContent = 'center';
      bigDiv.style.position = 'fixed';
      bigDiv.style.top = '0';
      bigDiv.style.right = '0';
      bigDiv.style.zIndex = '1000';
      bigDiv.style.display = isV3 ? 'none' : 'flex';
      const bigDivHeader = document.createElement('div');
      bigDivHeader.style.width = '100%';
      bigDivHeader.style.padding = '10px 20px';
      bigDivHeader.style.backgroundColor = 'rgba(0, 0, 0, 0.9)'; 
      bigDivHeader.style.marginTop = '2rem';
      bigDivHeader.style.fontSize = '14px';
      bigDivHeader.style.textAlign = 'center';
      bigDivHeader.innerText = text;
      bigDivHeader.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      const imgElement = document.createElement('img');
      imgElement.src = focus_image;
      imgElement.alt = 'Image';
      imgElement.style.width = '100%';
      imgElement.style.height = '100%';
      imgElement.style.objectFit = 'cover';
      imgElement.style.display = 'block';

      bigDiv.appendChild(bigDivHeader);
      bigDiv.appendChild(imgElement); 
      document.body.appendChild(bigDiv);

      const closeSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      closeSvg.setAttribute("width", "28");
      closeSvg.setAttribute("height", "28");
      closeSvg.setAttribute("viewBox", "0 0 40 41");
      closeSvg.innerHTML = `
          <rect y="0.9375" width="40" height="40" rx="20" fill="black" fill-opacity="0.6"></rect>
          <path d="M20.0019 22.5345L14.4126 28.1238C14.2035 28.3329 13.9373 28.4375 13.6141 28.4375C13.2909 28.4375 13.0248 28.3329 12.8156 28.1238C12.6065 27.9147 12.502 27.6485 12.502 27.3253C12.502 27.0021 12.6065 26.736 12.8156 26.5269L18.405 20.9375L12.8156 15.3481C12.6065 15.139 12.502 14.8729 12.502 14.5497C12.502 14.2265 12.6065 13.9603 12.8156 13.7512C13.0248 13.5421 13.2909 13.4375 13.6141 13.4375C13.9373 13.4375 14.2035 13.5421 14.4126 13.7512L20.0019 19.3405L25.5913 13.7512C25.8004 13.5421 26.0666 13.4375 26.3898 13.4375C26.713 13.4375 26.9791 13.5421 27.1883 13.7512C27.3974 13.9603 27.5019 14.2265 27.5019 14.5497C27.5019 14.8729 27.3974 15.139 27.1883 15.3481L21.5989 20.9375L27.1883 26.5269C27.3974 26.736 27.5019 27.0021 27.5019 27.3253C27.5019 27.6485 27.3974 27.9147 27.1883 28.1238C26.9791 28.3329 26.713 28.4375 26.3898 28.4375C26.0666 28.4375 25.8004 28.3329 25.5913 28.1238L20.0019 22.5345Z" fill="white"></path>
      `;
      closeSvg.classList.add('close-button');
      closeSvg.style.fill = "none";
      closeSvg.style.position = "absolute";
      closeSvg.style.top = "5px";
      closeSvg.style.left = "5px"; 
      closeSvg.style.right = "unset"; 
      closeSvg.style.cursor = "pointer";
      closeSvg.style.zIndex = "1501"; 
      bigDiv.appendChild(closeSvg);

      const expandSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      expandSvg.setAttribute("width", "24");
      expandSvg.setAttribute("height", "25");
      expandSvg.setAttribute("viewBox", "0 0 24 25");
      expandSvg.setAttribute("fill", "none");
      expandSvg.innerHTML = `
          <rect y="0.304688" width="24" height="24" rx="12" fill="black" fill-opacity="0.4"></rect>
          <path d="M8.56295 15.0489L10.285 13.3268C10.3823 13.2295 10.4967 13.1808 10.628 13.1808C10.7593 13.1808 10.8737 13.2295 10.971 13.3268C11.0683 13.4241 11.117 13.5385 11.117 13.6698C11.117 13.8011 11.0683 13.9154 10.971 14.0128L9.25596 15.7278L10.6597 15.7208C10.7957 15.7208 10.9124 15.768 11.0097 15.8624C11.107 15.9568 11.1557 16.0749 11.1557 16.2168C11.1557 16.3587 11.1085 16.4768 11.0141 16.5712C10.9197 16.6656 10.8016 16.7128 10.6597 16.7128L8.16368 16.7128C8.07807 16.7128 8.00273 16.6978 7.93765 16.6679C7.87257 16.638 7.81248 16.5955 7.75736 16.5404C7.70224 16.4853 7.65974 16.4252 7.62984 16.3601C7.59993 16.2951 7.58498 16.2197 7.58499 16.1341L7.58499 13.624C7.58498 13.488 7.63218 13.3737 7.72657 13.2811C7.82096 13.1884 7.93911 13.1421 8.081 13.1421C8.22288 13.1421 8.33985 13.1881 8.4319 13.2802C8.52396 13.3722 8.56998 13.4892 8.56998 13.6311L8.56295 15.0489ZM8.56998 9.55374L8.57702 10.9574C8.57702 11.0935 8.52983 11.2101 8.43543 11.3075C8.34102 11.4048 8.22288 11.4535 8.081 11.4535C7.93911 11.4535 7.82096 11.4063 7.72657 11.3119C7.63218 11.2175 7.58498 11.0993 7.58498 10.9574L7.58499 8.46146C7.58498 8.37585 7.59993 8.30051 7.62984 8.23543C7.65974 8.17035 7.70224 8.11026 7.75736 8.05514C7.81248 8.00002 7.87257 7.95752 7.93765 7.92762C8.00273 7.89771 8.07807 7.88276 8.16368 7.88277L10.6597 7.88276C10.7957 7.88276 10.9112 7.92879 11.0062 8.02084C11.1012 8.11289 11.1486 8.22985 11.1486 8.37174C11.1486 8.51363 11.1026 8.6306 11.0106 8.72265C10.9185 8.81471 10.8015 8.86073 10.6597 8.86072L9.24893 8.86073L10.971 10.5828C11.0683 10.6801 11.117 10.7944 11.117 10.9258C11.117 11.0571 11.0683 11.1714 10.971 11.2688C10.8737 11.3661 10.7593 11.4148 10.628 11.4148C10.4967 11.4148 10.3823 11.3661 10.285 11.2688L8.56998 9.55374Z" fill="white"></path>
      `;
      expandSvg.classList.add('expand-button');
      expandSvg.style.position = 'absolute';
      expandSvg.style.top = '5px';
      expandSvg.style.right = '5px';
      expandSvg.style.zIndex = '1001';  
      expandSvg.style.cursor = 'pointer';
      bigDiv.appendChild(expandSvg);
      expandSvg.addEventListener('click', (e) => {
        e.stopPropagation();
        
        // Clear any existing expanded view
        const existingExpandedDiv = document.querySelector('.expanded-div');
        if (existingExpandedDiv) {
          existingExpandedDiv.remove();
        }
        const expandedDiv = document.createElement('div');
        expandedDiv.className = 'expanded-div';
        expandedDiv.style.position = 'fixed';
        expandedDiv.style.top = '0';
        expandedDiv.style.left = '0';
        expandedDiv.style.width = '100vw';
        expandedDiv.style.height = '100vh';
        expandedDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        expandedDiv.style.zIndex = '1500';
        expandedDiv.style.display = 'flex';
        expandedDiv.style.flexDirection = 'column';
        expandedDiv.style.alignItems = 'center';
        expandedDiv.style.justifyContent = 'center';
        
        const header = document.createElement('div');
        header.style.width = '100%';
        header.style.padding = '10px 20px';
        header.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        header.style.color = 'white';
        header.style.fontSize = '18px';
        header.style.textAlign = 'center';
        header.style.marginBottom = '20px';
        header.innerText = text;
        header.addEventListener('click', (e) => {
          e.stopPropagation();
        });
        
        const leftButton = document.createElement('button');
        leftButton.innerText = '<';
        leftButton.style.position = 'absolute';
        leftButton.style.left = '10px';
        leftButton.style.top = '50%';
        leftButton.style.transform = 'translateY(-50%)';
        leftButton.style.zIndex = '1501';
        leftButton.style.cursor = 'pointer';
        leftButton.style.background = 'rgba(0, 0, 0, 0.5)';
        leftButton.style.border = 'none';
        leftButton.style.color = 'white';
        leftButton.style.fontSize = '20px';
        leftButton.style.padding = '10px';

        const rightButton = document.createElement('button');
        rightButton.innerText = '>';
        rightButton.style.position = 'absolute';
        rightButton.style.right = '10px';
        rightButton.style.top = '50%';
        rightButton.style.transform = 'translateY(-50%)';
        rightButton.style.zIndex = '1501';
        rightButton.style.cursor = 'pointer';
        rightButton.style.background = 'rgba(0, 0, 0, 0.5)';
        rightButton.style.border = 'none';
        rightButton.style.color = 'white';
        rightButton.style.fontSize = '20px';
        rightButton.style.padding = '10px';

        const imageContainer = document.createElement('div');
        imageContainer.style.width = '80%';
        imageContainer.style.height = '70%';
        imageContainer.style.display = 'flex';
        imageContainer.style.alignItems = 'center';
        imageContainer.style.justifyContent = 'center';
        imageContainer.style.overflow = 'hidden';
        imageContainer.style.borderRadius = '10px';

        const expandedImg = document.createElement('img');
        expandedImg.src = focus_image;
        expandedImg.alt = 'Expanded Image';
        expandedImg.style.width = '100%';
        expandedImg.style.height = 'auto';
        expandedImg.style.objectFit = 'contain';

        imageContainer.appendChild(expandedImg);

        const updateExpandedView = (hotspotData) => {
          if (Array.isArray(hotspotData) && hotspotData.length > 0) {
            if (currentIndex >= 0 && currentIndex < hotspotData.length) {
              if (hotspotData[currentIndex] && hotspotData[currentIndex].focus_image_url && hotspotData[currentIndex].type) {
                expandedImg.src = hotspotData[currentIndex].focus_image_url;
                header.innerText = hotspotData[currentIndex].type;
              } else {
                console.error('Invalid hotspot data at index:', currentIndex);
                expandedImg.src = focus_image;  
                header.innerText = text;
              }
            } else {
              console.error('currentIndex is out of bounds:', currentIndex);
            }
          } else {
            console.error('hotspotData is not a valid array or is empty');
          }
        };

        leftButton.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex > 0) {
            currentIndex--;
          } else {
            currentIndex = hotspotData.length - 1;
          }
          updateExpandedView(hotspotData);
        });

        rightButton.addEventListener('click', (e) => {
          e.stopPropagation();
          if (currentIndex < hotspotData.length - 1) {
            currentIndex++;
          } else {
            currentIndex = 0;
          }
          updateExpandedView(hotspotData);
        });

        const closeSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        closeSvg.setAttribute("width", "34");
        closeSvg.setAttribute("height", "34");
        closeSvg.setAttribute("viewBox", "0 0 40 41");
        closeSvg.innerHTML = `
            <rect y="0.9375" width="40" height="40" rx="20" fill="black" fill-opacity="0.6"></rect>
            <path d="M20.0019 22.5345L14.4126 28.1238C14.2035 28.3329 13.9373 28.4375 13.6141 28.4375C13.2909 28.4375 13.0248 28.3329 12.8156 28.1238C12.6065 27.9147 12.502 27.6485 12.502 27.3253C12.502 27.0021 12.6065 26.736 12.8156 26.5269L18.405 20.9375L12.8156 15.3481C12.6065 15.139 12.502 14.8729 12.502 14.5497C12.502 14.2265 12.6065 13.9603 12.8156 13.7512C13.0248 13.5421 13.2909 13.4375 13.6141 13.4375C13.9373 13.4375 14.2035 13.5421 14.4126 13.7512L20.0019 19.3405L25.5913 13.7512C25.8004 13.5421 26.0666 13.4375 26.3898 13.4375C26.713 13.4375 26.9791 13.5421 27.1883 13.7512C27.3974 13.9603 27.5019 14.2265 27.5019 14.5497C27.5019 14.8729 27.3974 15.139 27.1883 15.3481L21.5989 20.9375L27.1883 26.5269C27.3974 26.736 27.5019 27.0021 27.5019 27.3253C27.5019 27.6485 27.3974 27.9147 27.1883 28.1238C26.9791 28.3329 26.713 28.4375 26.3898 28.4375C26.0666 28.4375 25.8004 28.3329 25.5913 28.1238L20.0019 22.5345Z" fill="white"></path>
        `;
        closeSvg.classList.add('close-button');
        closeSvg.style.fill = "none";
        closeSvg.style.position = "absolute";
        closeSvg.style.top = "20px";
        closeSvg.style.right = "20px";
        closeSvg.style.cursor = "pointer";
        closeSvg.style.zIndex = "1501"; 

        closeSvg.addEventListener('click', (e) => {
          e.stopPropagation();
          expandedDiv.remove();
          enableKeyboardInput();
        });
        expandedDiv.appendChild(header);
        expandedDiv.appendChild(imageContainer);
        expandedDiv.appendChild(leftButton);
        expandedDiv.appendChild(rightButton);
        expandedDiv.appendChild(closeSvg);
        document.body.appendChild(expandedDiv);
        disableKeyboardInput();
        expandedDiv.addEventListener('click', (e) => {
          if (e.target === expandedDiv) {
            expandedDiv.remove();
            enableKeyboardInput();
          }
        });
      });



      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.style.position = "fixed";
      svg.style.top = "0";
      svg.style.left = "0";
      svg.style.width = "100%";
      svg.style.height = "100%";
      svg.style.pointerEvents = "none";
      svg.style.zIndex = "10";
      svg.classList.add("hotspot-svg");

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      const hotspotRect = hotSpotDiv.getBoundingClientRect();
      const circleCenterX = hotspotRect.left + hotspotRect.width / 2 - 3;
      const circleCenterY = hotspotRect.top + hotspotRect.height / 2 - 3;
      const circleRadius = 16.5;
      circle.setAttribute("cx", circleCenterX);
      circle.setAttribute("cy", circleCenterY);
      circle.setAttribute("r", circleRadius);
      circle.setAttribute("fill", "none");
      circle.setAttribute("stroke", "#fff");
      circle.setAttribute("stroke-width", "1");
      circle.classList.add("circle");
      const angle = Math.atan2(bigDiv.offsetTop + bigDiv.offsetHeight - circleCenterY, bigDiv.offsetLeft - circleCenterX);
      const startX = circleCenterX + circleRadius * Math.cos(angle);
      const startY = circleCenterY + circleRadius * Math.sin(angle);

      const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
      line.setAttribute("x1", startX + 30);
      line.setAttribute("y1", startY + 5);
      if(isV3){ 
          // Point line directly to UspComponentT1 modal LEFT EDGE
          // Modal: right-4 (16px) + max-width 400px = left edge
          const modalLeftEdgeX = window.innerWidth - 16 - 390; // Full modal width to get left edge
          line.setAttribute("x2", modalLeftEdgeX);
          line.setAttribute("y2", startY + 5);
      }
      else{
        line.setAttribute("x2", bigDiv.offsetLeft);
        line.setAttribute("y2", bigDiv.offsetTop + bigDiv.offsetHeight);
      }
      line.classList.add("connection-line");

      svg.appendChild(circle, svg.style.top = "-3px", svg.style.left = "-3px");
      svg.appendChild(line);
      document.body.appendChild(svg);

      const closeHandler = (e) => {
        e.stopPropagation();
        clearPreviousHotspot();
        setHandlerMobileHotspot(false);
        if(isV3){
          setToggleInteriorHotspot(false);
          // Update both inline styles and CSS classes
          document.querySelectorAll('.pnlm-hotspot-base').forEach((hotspot) => {
            // Remove both classes first
            hotspot.classList.remove(Styles['visible-hotspot']);
            hotspot.classList.remove(Styles['hidden-hotspot']);
            // Add the hidden class
            hotspot.classList.add(Styles['hidden-hotspot']);
            // Set inline visibility
            hotspot.style.visibility = 'hidden';
          });
          dispatch(setToggleInteriorHotspot(false));
          dispatch(setToggleHotspotView(false));
      }
        document.removeEventListener('click', closeHandler);
      };

      bigDiv.addEventListener('click', closeHandler);
      if(!isV3) document.addEventListener('click', closeHandler);

    }
    hotSpotDiv.addEventListener('mouseover', createTooltip);
    hotSpotDiv.addEventListener('mouseleave', removeTooltip);
    hotSpotDiv.addEventListener('click', (e) => {
      e.stopPropagation();
      if (typeof stopAutoRotationFn === 'function') {
        stopAutoRotationFn();
      }
      const currentIndex = hotspotData.findIndex(h => h.focus_image_url === focus_image);
      dispatch(setInteriorHotspotIndex(currentIndex));
      createBigDiv(focus_image, text, currentIndex);
      setTimeout(() => {
        const targetDiv = isV3 ? null : document.querySelector('.big-div');
        if (isV3 || targetDiv) {
          drawHotspotLine(hotSpotDiv, targetDiv, isV3, toggleHotspotRef.current, selectedTemplate, isMobileFullScreen);
        }
      }, 0);
    });

    createRipple();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const hotspot = document.createElement('div');
    hotspot.style.width = '0px';
    hotspot.style.height = '0px';
    hotspot.style.backgroundColor = 'red';
    hotspot.style.position = 'absolute';
    hotspot.style.top = '100px';
    hotspot.style.left = '100px';
    document.body.appendChild(hotspot);
    setupHotspotTooltip(hotspot, '', 'This is a hotspot', stopAutoRotation);
  });

  useEffect(() => {
    if (viewerRef.current) {
      const viewer = viewerRef.current.getViewer();
      setTimeout(() => {
        (hotspotsJson || []).forEach((hotspot) => {
          const { yaw, pitch } = convertCoordinates(hotspot.coordinates.x, hotspot.coordinates.y);
        });
      }, 500);
    }
  }, []);

  useEffect(() => { 
    if(!toggleInteriorHotspots){
      document.querySelectorAll('.big-div, .background-overlay, .expanded-div').forEach(el => el.remove());
    }
  }, [toggleInteriorHotspots]);

  // Add Pannellum drag detection
  useEffect(() => {
    if (viewerRef.current) {
      const viewer = viewerRef.current.getViewer();
      const pannellumContainer = viewer?.getContainer();
      
      if (pannellumContainer) {
        // const handleMouseDown = (e) => {
        //   setIsPannellumDragging(true);
        // };
        
        // const handleMouseUp = (e) => {
        //   setIsPannellumDragging(false);
        // };
        
        // const handleMouseLeave = (e) => {
        //   setIsPannellumDragging(false);
        // };
        let mouseDown = false;
        let mouseMoved = false;

        const handleMouseDown = (e) => {
          mouseDown = true;
          mouseMoved = false;
        };

        const handleMouseMove = (e) => {
          if (mouseDown) {
            mouseMoved = true;
            setIsPannellumDragging(true);
          }
        };

        const handleMouseUp = (e) => {
          mouseDown = false;
          setIsPannellumDragging(false);
        };

        const handleMouseLeave = (e) => {
          mouseDown = false;
          setIsPannellumDragging(false);
        };

        // const handleTouchStart = (e) => {
        //   if (e.touches.length === 1) { // Only for single touch (rotation), not pinch zoom
        //     setIsPannellumDragging(false);
        //   }
        //   else {setIsPannellumDragging(true);}
        // };
        
        // const handleTouchEnd = (e) => {
        //   setIsPannellumDragging(false);
        // };
        let touchMoved = false;

        const handleTouchStart = (e) => {
          touchMoved = false;
        };

        const handleTouchMove = (e) => {
          touchMoved = true;
          setIsPannellumDragging(true);
        };

        const handleTouchEnd = (e) => {
          setIsPannellumDragging(false);
        };

        // Add event listeners
        pannellumContainer.addEventListener('mousedown', handleMouseDown);
        pannellumContainer.addEventListener('mousemove', handleMouseMove);
        pannellumContainer.addEventListener('mouseup', handleMouseUp);
        pannellumContainer.addEventListener('mouseleave', handleMouseLeave);
        pannellumContainer.addEventListener('touchstart', handleTouchStart);
        pannellumContainer.addEventListener('touchmove', handleTouchMove);
        pannellumContainer.addEventListener('touchend', handleTouchEnd);

        return () => {
          // Cleanup event listeners
          pannellumContainer.removeEventListener('mousedown', handleMouseDown);
          pannellumContainer.removeEventListener('mousemove', handleMouseMove);
          pannellumContainer.removeEventListener('mouseup', handleMouseUp);
          pannellumContainer.removeEventListener('mouseleave', handleMouseLeave);
          pannellumContainer.removeEventListener('touchstart', handleTouchStart);
          pannellumContainer.removeEventListener('touchmove', handleTouchMove);
          pannellumContainer.removeEventListener('touchend', handleTouchEnd);
        };
      }
    }
  }, [viewerRef.current]);

  const renderHotspots = (hotspotsData) => {
    let renderedIndex = 0;
    return (hotspotsJson || [])?.map((hotspot,index) => {
      const { yaw, pitch } = convertCoordinates(hotspot.coordinates.x, hotspot.coordinates.y);
      if (isImageIdValid && typeof yaw === 'number' && !isNaN(yaw) && typeof pitch === 'number' && !isNaN(pitch) ) {
        const hotspotClass = toggleInteriorHotspots ? 'visible-hotspot' : 'hidden-hotspot';

        const currentRenderedIndex = renderedIndex;
        renderedIndex++;
        
        if (hotspot.type === 'tag') {
          return (
            <Pannellum.Hotspot
              key={hotspot.hotspot_id}
              type="custom"
              pitch={pitch}
              yaw={yaw}
              cssClass={`${Styles['custom-hotspot']} ${Styles['custom-hotspot-icon']} ${Styles[hotspotClass]}`}
              handleClick={(evt, args) => {
                stopAutoRotation();
                dispatch(setInteriorHotspotIndex(index));
                // Call the onHotspotClick callback if provided
                if (onHotspotClick && hotspot.hotspot_id) {
                  onHotspotClick(hotspot.hotspot_id, index);
                }
              }}
              tooltip={(hotSpotDiv) => {
                // Add data attributes to help with mapping
                hotSpotDiv.setAttribute('data-original-index', index);
                hotSpotDiv.setAttribute('data-rendered-index', currentRenderedIndex);
                return setupHotspotTooltip(hotSpotDiv, hotspot.focus_image_url, `${hotspot.reasons}`, stopAutoRotation);
              }}
              handleClickArg={{ name: hotspot.reasons }}
            />
          );
        }
        else {
          return (
            <Pannellum.Hotspot
              key={hotspot.hotspot_id}
              type="custom"
              pitch={pitch}
              yaw={yaw}
              cssClass={`${Styles['custom-hotspot']} ${Styles['custom-hotspot-icon-tag']} ${Styles[hotspotClass]}`}
              handleClick={(evt, args) => {
                stopAutoRotation();
                // Call the onHotspotClick callback if provided
                if (onHotspotClick && hotspot.hotspot_id) {
                  onHotspotClick(hotspot.hotspot_id, index);
                }
              }}
              tooltip={(hotSpotDiv) => {
                // Add data attributes to help with mapping
                hotSpotDiv.setAttribute('data-original-index', index);
                hotSpotDiv.setAttribute('data-rendered-index', currentRenderedIndex);
                return setupHotspotTooltip(hotSpotDiv, hotspot.focus_image_url, `${hotspot.reasons}`, stopAutoRotation);
              }}
              handleClickArg={{ name: hotspot.reasons }}
            />
          );
        }

      }
      return null;
    }).filter(Boolean); 
  };

  useEffect(() => {
    if (viewerRef.current && state?.selectedUrl?.url && automatedImageSpin) {
      const viewer = viewerRef.current.getViewer();
      if (viewer && typeof viewer.startAutoRotate === 'function') {
          viewer.startAutoRotate(5);
      }
    } 
  }, [automatedImageSpin]);

  useEffect(() => {
    if (incrementClickedInterior !== undefined && !automatedImageSpin) {
      if (viewerRef.current && state?.selectedUrl?.url) {
        const viewer = viewerRef.current.getViewer();
        if (viewer && typeof viewer.stopAutoRotate === 'function') {
          viewer.stopAutoRotate(); 
        }
      }
    }
  }, [incrementClickedInterior, automatedImageSpin, state?.selectedUrl?.url]);

  return (
    <>
      {(isMobileView && !checkIsV3()) && <div style={{ position: "absolute", height: "5vw", width: "10vw", zIndex: "111" }}>
        <InteriorMobileToggleHandler
          isSpanish={spanishEnterprise}
          ToggleInteriorHotspots={toggleInteriorHotspots}
          handlerMobileHotspot={toggleInteriorHotspots}
          setHandlerMobileHotspot={setHandlerMobileHotspot}
          toggleHotspotVisibility={toggleHotspotVisibility}
        />
      </div>}
      {state?.interior360Url?.map((frames, index) => {
        if (state?.selectedUrl?.url !== (frames?.output_image_hres_url ? frames?.output_image_hres_url : frames?.input_image_hres_url)) return null;

        return (
          <div key={index} ref={containerRef}
            style={{
              width: isV2 ? "" : isV3 ? "100%" : '100vw',
              height: isV3 ? "100%" : '100vh',
              position: 'relative',
            }}
          >
            {isMobileView ? <Pannellum
              ref={viewerRef}
              width={isV3 ? "100vw" : "100%"}
              height={isV3 ? "100vh" : "100%"}
              hfov={50}
              image={`https://media.spyneai.com/unsafe/2400x1200/filters:format(webp)/${state?.selectedUrl?.url}`}
              pitch={-20}
              yaw={-25}
              
              // haov={180}
              // vaov={180}
              autoLoad={true}
              autoRotate={5}
              showZoomCtrl={false}
              onError={handleError}
              showControls={false}
              onMouseDown={() => setIsPannellumDragging(true)}
              onMouseUp={() => setIsPannellumDragging(false)}
              // onLoad={handleOnLoad}
            >

              {(hotspotsJson?.interior_tagged_images?.hotspots || []) && renderHotspots(hotspotsJson?.interior_tagged_images?.hotspots)}
            </Pannellum> :
              <Pannellum
                ref={viewerRef || null}
                width="100%"
                height="100%"
                hfov={120}
                image={`https://media.spyneai.com/unsafe/2400x1200/filters:format(webp)/${state?.selectedUrl?.url}`}
                pitch={-30}
                yaw={-35}
                autoRotate={5}
                autoLoad={true}
                showZoomCtrl={false}
                onError={handleError}
                showControls={false}
                onMouseDown={() => setIsPannellumDragging(true)}
                onMouseUp={() => setIsPannellumDragging(false)}
                // onLoad={handleOnLoad}
              >
                

            {(hotspotsJson?.interior_tagged_images?.hotspots || [])  ? renderHotspots(hotspotsJson?.[0]?.hotspots) : null}
              </Pannellum>
            }
          </div>
        );
      })}
    </>
  );
});

export default InteriorIframe;

